module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-page"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "company-page-loader"
  }, [_c('loading')], 1) : _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 offset-md-2 col-lg-offset-4 col-lg-4 col-xl-4"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_vm._m(0), _vm._v(" "), (!!_vm.company.name) ? _c('h4', {
    staticClass: "company-name"
  }, [_vm._v(_vm._s(_vm.company.name))]) : _vm._e(), _vm._v(" "), (!!_vm.company.website) ? _c('p', {
    staticClass: "company-website"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "link": "",
      "target": "_blank",
      "href": 'http://' + _vm.company.company_website
    }
  }, [_vm._v(_vm._s(_vm.company.company_website))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.created")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.company.created_at)) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.updated")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.company.updated_at)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "company-details"
  }, [_c('div', {
    staticClass: "company-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.company.company_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.setIsOpen(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.edit")))])]), _vm._v(" "), _vm._l((_vm.standardCompanyFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [(entry.display_name) ? _c('p', {
      staticClass: "title-subtext"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.caption" + "." + entry.internal_name)) + "\n          ")]) : _vm._e(), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'country') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.country) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [(_vm.contacts.length > 0) ? _c('div', {
    staticClass: "contact-panel"
  }, [_c('h5', {
    staticClass: "contact-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.contacts")) + "\n          (" + _vm._s(this.totalContacts) + ")\n        ")]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: 'contact-' + contact.id,
      staticClass: "company-wrapper"
    }, [_c('q-card-title', {
      staticClass: "contact-card"
    }, [_c('user-image', {
      attrs: {
        "firstname": contact.firstname,
        "lastname": contact.lastname,
        "email": contact ? contact.email : '',
        "size": "small"
      }
    }), _vm._v(" "), (contact.name) ? _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), (contact && contact.email) ? _c('p', {
      staticClass: "caption contact-title-sublabel",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(contact.email) + "\n              ")]) : _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.email")) + "\n              ")])]) : (contact.company && contact.email) ? _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v("\n                " + _vm._s(contact.email) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.name")) + "\n              ")])]) : _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.headline")) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.email_name")) + "\n              ")])]), _vm._v(" "), _c('q-icon', {
      attrs: {
        "slot": "right",
        "name": "more_horiz"
      },
      slot: "right"
    }, [_c('q-popover', {
      staticClass: "contact-actions-popover"
    }, [_c('q-list', {
      staticClass: "no-border",
      attrs: {
        "link": ""
      }
    }, [_c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }]
    }, [_c('q-item-main', {
      staticClass: "contact-action-item",
      attrs: {
        "label": _vm.$t('ui.company.contact.go_to_contact')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToContact(contact.id)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-link"
  }, [_c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.goToContacts()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.contact.view_all")) + "\n          ")])])], 2) : _c('div', [_c('empty-state', {
    attrs: {
      "name": "collaborators",
      "subtitle": _vm.$t('ui.company.empty_state_text')
    }
  })], 1)])]), _vm._v(" "), _c('company-edit', {
    attrs: {
      "isOpen": _vm.isOpen,
      "company": _vm.company
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      },
      "save": _vm.updateCompany
    }
  }), _vm._v(" "), _c('modal', {
    staticClass: "delete-modal",
    attrs: {
      "open": _vm.deleteModalOpen,
      "title": _vm.$t('ui.company.modals.delete.title'),
      "subtitle": _vm.deleteCompanySubtitle,
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.company.modals.delete.confirm'),
      "saveDisabled": _vm.deleteCompanyNameConfirm != _vm.$t('ui.company.modals.delete.confirm_word')
    },
    on: {
      "save": _vm.deleteCompany,
      "cancel": function($event) {
        return _vm.openDeleteModal(false)
      }
    }
  }, [_c('field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('ui.company.modals.delete.label')
    },
    model: {
      value: (_vm.deleteCompanyNameConfirm),
      callback: function($$v) {
        _vm.deleteCompanyNameConfirm = $$v
      },
      expression: "deleteCompanyNameConfirm"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    staticClass: "source-image",
    attrs: {
      "src": require("../../../assets/company.svg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-455bbaaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/companies/Company.vue
// module id = 1887
// module chunks = 0